/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Vue from "vue";
import Router from "vue-router";
import { RouterNameEnum } from "@/router/router.types";

import { StoreRoutes } from "@/router/Routes/store";
import { BaseRoutes } from "@/router/Routes/base";
import { StudiosRoutes } from "@/router/Routes/studios";
import { ReportRoutes } from "@/router/Routes/reports";
import { ClientRoutes } from "@/router/Routes/clients";
import { ServicesRoutes } from "@/router/Routes/service";
import { LoyaltyRoutes } from "@/router/Routes/loyalty";
import { FinanceRoutes } from "@/router/Routes/finance";
import { VisitsRoutes } from "./Routes/visits";
import { HomeRoutes } from "@/router/Routes/home";
import { SettingsRoutes } from "@/router/Routes/settings";
import { checkUserRole, getUserData } from "@/router/Lib/helper";
import { TestRoutes } from "@/router/Routes/test";
import { VisitsNewRoutes } from "@/router/Routes/visitsnew"
import { SalaryCalculations } from "@/router/Routes/salaryСalculations"


import axios from "axios";
import store from '@/store/index'
import {AuthStore} from '@/store/modules/Auth';
import {message} from 'ant-design-vue';
//import Vuex, { Store } from 'vuex';

Vue.use(Router);
Vue.prototype.$routeRules = RouterNameEnum;

const AppRoutes = [
    ...BaseRoutes,
    ...StudiosRoutes,
    ...StoreRoutes,
    ...ReportRoutes,
    ...ClientRoutes,
    ...ServicesRoutes,
    ...LoyaltyRoutes,
    ...FinanceRoutes,
    ...HomeRoutes,
    ...SettingsRoutes,
    ...VisitsRoutes,
    ...TestRoutes,
    ...VisitsNewRoutes,
    ...SalaryCalculations
];

Vue.router = new Router({
    mode: "hash",
    //mode: 'history',
    fallback: true,
    base: process.env.BASE_URL,
    // routes,
    routes: AppRoutes,
});
export const router = Vue.router;

// export const getRoutes = () => AppRoutes;

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response !== undefined && error.response.status !== undefined) {
            if (error.response.status === 423 && error.response.data.code === 'subscription_restricted') {
                AuthStore.setCompanySubscription({...AuthStore.companySubscription, ...error.response.data.subscription});
                message.warning(error.response.data.response);
                window.dispatchEvent(new Event('pult-subscription-changed'));
            }
            if (error.response.status === 404) {
                return router.push({ path: '/' })
                /*return new Promise((resolve, reject) => {
                    reject(error);
                });*/
            }
            if (error.response.status === 500) {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
            if (error.response.status === 401) {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        }
        return Promise.reject(error);
    },
);
router.beforeEach((to, from, next) => {
    const authorize = to.meta;
    const chkRole = checkUserRole;
    const userData = getUserData();

    //TODO::Устанавливаем Salon ID
    if(userData['studios'] && !store.state["salon_id"])
    {
        store.commit("changeSalon",userData["studios"])
    }

    // let AuthStatus = false
    let allowNext = true;
    if (authorize !== undefined) {
        if (authorize.role !== undefined && authorize.role !== chkRole()) {
            allowNext = false;
        }
    }

    if (allowNext) {
        next();
    } else {
        next("/dashboard");
    }
});
router.onError((error) => {
    const pattern = /Loading chunk chunk-(\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.currentRoute.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});
/*
router.beforeEach((to, from, next) => {
    const publicPages = ['/auth'];
    next();

    /*const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');

    if (authRequired && !loggedIn) {
        next('/login');
    } else {
        next();
    }
})
*/

/* router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    }
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode?.removeChild(el));
    if (!nearestWithMeta) {
        return next();
    }
    nearestWithMeta.meta.metaTags.map((tagDef: any) => {
        const tag = document.createElement('meta');
        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute('data-vue-router-controlled', '');
        return tag;
    })
        .forEach((tag: any) => document.head.appendChild(tag));
    next();
}); */
